import BasicValidation from 'components/components/common/BasicValidation';

const GOOGLE_STREET_TYPE = 'street_number';
const GOOGLE_POSTALCODE_TYPE = 'postal_code';

export default class AddressValidation extends BasicValidation {
  constructor(object) {
    super();
    this.placeObject = object;
    this.street = null;
    this.postcode = null;
    this.parseObject();
  }

  getLatAndLng(){
    if (this.placeObject.geometry) {
      if (this.placeObject.geometry.location) {
        return {
          'lat': this.placeObject.geometry.location.lat,
          'lng': this.placeObject.geometry.location.lng
        };
      }
    }
    return {lat: null, lng: null};
  }

  areCoordsValid() {
    var coords = this.getLatAndLng();
    return coords["lat"] && coords["lng"];
  }

  parseObject() {
    var addressComponents = this.placeObject.address_components;
    for (var i = 0; i < addressComponents.length; i++) {
      var acItem = addressComponents[i];
      if (acItem.types[0] === GOOGLE_STREET_TYPE) {
        this.street = acItem.short_name;
      }

      if (acItem.types[0] === GOOGLE_POSTALCODE_TYPE) {
        this.postcode = acItem.short_name;
      }

    }
  }

  isStreetValid() {
    return (this.street !== null && this.street !== '');
  }

  isPostCodeValid() {
    return (this.postcode !== null && this.postcode !== '');
  }

}
